import React, { DetailedHTMLProps, HTMLAttributes, useState } from "react";

import StepCollapse from "../_components/StepCollapse";
import { useQuoteRequestSelector } from "../_store";
import { QuoteStepIndex } from "../types";

type Props = {
  expectedStepIndex: QuoteStepIndex;
  name: string;
  number: number;
  tag?: React.ReactNode;
  footer?: React.ReactNode;
  divProps?: DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>;
  headerDivProps?: DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>;
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const useCreateStepCollapseProps = ({
  expectedStepIndex,
  name,
  number,
  divProps,
  footer,
  headerDivProps,
  tag,
}: Props) => {
  const [isOpen, setIsOpen] = useState(true);
  const stepIndex = useQuoteRequestSelector((store) => store.quoteRequestSliceV2.stepIndex);

  const baseStepCollapseProps: React.ComponentProps<typeof StepCollapse> = {
    collapseIn: isOpen,
    visible: stepIndex >= expectedStepIndex,
    name,
    number,
    divProps,
    footer,
    headerDivProps: { ...headerDivProps, onClick: () => setIsOpen(!isOpen) },
    tag,
  };

  return {
    baseStepCollapseProps,
    setIsOpen,
  };
};
